import { useEffect, useMemo, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import Skeleton from 'react-loading-skeleton';
import { Link } from 'react-router';

import { useGetOperationHistory } from '@/api';
import { Operation } from '@/api/types';
import { OperationList } from '@/components/OperationHistory/OperationList/OperationList.tsx';
import { Button } from '@/components/shared/Button';
import { PageHeading } from '@/components/shared/PageHeading/PageHeading.tsx';
import { timeZone } from '@/constants';
import { groupByDate } from '@/utils';

import cn from './styles.module.sass';

export const OperationHistory = () => {
    const [operationHistory, setOperationHistory] = useState<Operation[]>([]);
    const [page, setPage] = useState<number>(1);
    const [hasMore, setHasMore] = useState(true);

    const { data, isLoading } = useGetOperationHistory(page);

    const groupedOperations = useMemo(
        () => groupByDate(operationHistory, timeZone),
        [operationHistory]
    );

    const loadMore = async () => {
        if (data && !Array.isArray(data)) {
            if (data.list.length > 0) {
                setPage(page + 1);
            } else {
                setHasMore(false);
            }
        }
    };

    useEffect(() => {
        if (data) {
            if (!Array.isArray(data) && data.list.length > 0) {
                setOperationHistory(
                    operationHistory.length === 0 ? data.list : operationHistory.concat(data.list)
                );
            } else {
                setHasMore(false);
            }
        }
    }, [data]);

    return (
        <div className={cn.container}>
            <PageHeading pageName="История операций" />
            <div className={cn.history}>
                {operationHistory.length === 0 && !isLoading ? (
                    <div className={cn.noOperations}>
                        <div className={cn.letterContainer}>
                            <span>Б</span>
                        </div>
                        <div className={cn.noOperationsText}>Еще нет операций</div>
                        <Link to="/">
                            <Button>Выбрать номера</Button>
                        </Link>
                    </div>
                ) : (
                    <InfiniteScroll
                        next={loadMore}
                        hasMore={hasMore}
                        loader={
                            <Skeleton
                                count={5}
                                height={32}
                                containerClassName={cn.skeletonContainer}
                            />
                        }
                        dataLength={operationHistory.length}
                    >
                        {Object.keys(groupedOperations).length > 0 &&
                            Object.entries(groupedOperations).map(([date, operations]) => (
                                <OperationList
                                    key={date}
                                    date={date}
                                    timeZone={timeZone}
                                    operations={operations}
                                />
                            ))}
                    </InfiniteScroll>
                )}
            </div>
        </div>
    );
};
